import React from 'react';
import { ItemTable } from '../components/ItemComponents/ItemTable';
import { WarehouseTable } from '../components/WarehouseComponents/WarehouseTable';

export function ListWarehousesPage() {
  return (
    <WarehouseTable/>
  );
}
      
